/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { success, error } from '@/libs/notification';
import router from '@/router';
import {
  PackageState,
  PackageDetailDataState,
  PackagePutDataState,
  PackageItemData,
  AddItemData
} from '@/types/master/package';
import _ from 'lodash';

import { ElLoading } from 'element-plus';
import { handleAuthorizationError } from '@/libs/apiErrorHandler';
import { getAccessToken } from '@/libs/firebaseAuth';
import { getBaseUrl } from '@/libs/env';
import { classificationPayload } from '@/libs/pack';

export default {
  namespaced: true,
  state: {
    detailData: null,
    putData: null
  },
  mutations: {
    setDetail(state: PackageState, payload: PackageDetailDataState) {
      state.detailData = payload;
    },
    setPut(state: PackageState, payload: PackagePutDataState) {
      state.putData = payload;
    }
  },
  actions: {
    async fetch(context: any, packageMasterId: any) {
      await axios
        .get(getBaseUrl() + '/master/packs/' + packageMasterId, {
          headers: { auth: await getAccessToken() }
        })
        .then((response) => {
          context.commit('setDetail', response.data);
          const copyData = _.cloneDeep(response.data);
          const details = copyData.details.map(
            (item: PackageItemData): AddItemData => {
              return {
                itemId: item.itemId,
                itemQty: item.itemQty,
                itemHandlingType: item.itemHandlingType
              };
            }
          );
          context.commit('setPut', {
            id: copyData.id,
            name: copyData.name,
            packCode: copyData.packCode,
            isChangeHarnessItem: copyData.isChangeHarnessItem,
            ...classificationPayload(copyData),
            details: details
          });
        })
        .catch(async (e) => {
          if (e.response.status === 401) {
            await handleAuthorizationError();
          } else if (e.response.status == 404) {
            error(e.response.status, 'パッケージ情報が存在しません。');
            router.push('/master/package');
          } else if (e.response.status < 500) {
            error(e.response.status);
            router.push('/master/package');
          } else {
            router.push('/error/server');
          }
        });
    },
    async delete(context: any, packageMasterId: string) {
      const loadingInstance = ElLoading.service({ fullscreen: true });
      await axios
        .delete(getBaseUrl() + '/master/packs/' + packageMasterId, {
          headers: { auth: await getAccessToken() }
        })
        .then(() => {
          success('success', 'パッケージ情報の削除に成功しました。');
          router.push('/master/package');
        })
        .catch(async (e) => {
          loadingInstance.close();
          if (e.response.status === 401) {
            await handleAuthorizationError();
          } else if (e.response.status == 404) {
            error(e.response.status, 'パッケージ情報が存在しません。');
            router.push('/master/package');
          }
          if (e.response.status < 500) {
            error(e.response.status);
          } else {
            router.push('/error/server');
          }
        });
    },
    async put(context: any, payload: PackagePutDataState) {
      const loadingInstance = ElLoading.service({ fullscreen: true });
      const classification = classificationPayload(payload);
      await axios
        .put(
          getBaseUrl() + '/master/packs/' + payload.id,
          {
            name: (payload.name ?? '').trim(),
            packCode: payload.packCode,
            isChangeHarnessItem: payload.isChangeHarnessItem,
            ...classification,
            details: payload.details
          },
          {
            headers: { auth: await getAccessToken() }
          }
        )
        .then(() => {
          success('Success', 'パッケージ情報の変更に成功しました。');
          router.push('/master/package');
        })
        .catch(async (e) => {
          loadingInstance.close();
          if (e.response.status === 401) {
            await handleAuthorizationError();
          } else if (e.response.status == 404) {
            error(e.response.status, 'パッケージ情報が存在しません。');
            router.push('/master/package');
          } else if (e.response.status < 500) {
            error(e.response.status);
          } else {
            router.push('/error/server');
          }
        });
    }
  }
};
